/**
 * The three staggered bounce dots that signal the PM is composing a reply.
 * Extracted from IssueDetailPage so the chat thread and the issue timeline
 * render an identical "thinking" affordance.
 *
 * Renders inline dots only; callers wrap them with whatever label/layout suits
 * (a grouped chat pseudo-message, a bordered banner, …).
 */
export function PmThinkingDots({ className = '' }: { className?: string }) {
  return (
    <span
      className={`flex gap-0.5 ${className}`}
      role="status"
      aria-label="PM is thinking"
    >
      <span className="animate-bounce [animation-delay:-0.3s]">·</span>
      <span className="animate-bounce [animation-delay:-0.15s]">·</span>
      <span className="animate-bounce">·</span>
    </span>
  );
}
